import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  OnDestroy,
} from "@angular/core";
import { Router } from "@angular/router";
import { ProjectService } from "src/app/shared/services/project.service";
import { NgxSpinnerService } from "ngx-spinner";
import textConfiguration from "src/assets/static-text-configuration.json";
import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
} from "@angular/cdk/drag-drop";
import { ScorecardService } from "src/app/shared/services/scorecard.service";
import { MatSlider } from "@angular/material/slider";
import { FilterService } from "src/app/shared/services/filter.service";
import { MatDialog } from "@angular/material/dialog";
import { forkJoin, Subject } from "rxjs";
import { WhatIfComponent } from "src/app/pages/kepler/what-if/what-if.component";
import { PulsesDialogComponent } from "src/app/pages/delivery-functionality/pulses-dialog/pulses-dialog.component";
import { PeopleInsightsComponent } from "src/app/shared/components/people-insights/people-insights.component";
import { CommonService } from "src/app/shared/services/common.service";
import { IncidentTrackerService } from "src/app/shared/services/incident-tracker.service";
import { GovernanceLighthouseService } from "src/app/shared/services/governance-lighthouse.service";
import { AssessmentCentralService } from "src/app/shared/services/assessment-central.service";
import Highcharts from "highcharts";
import noData from "highcharts/modules/no-data-to-display";
import More from "highcharts/highcharts-more";
import HC_solidGauge from "highcharts/modules/solid-gauge";
import { takeUntil } from "rxjs/operators";
import { LoggingService } from "src/app/logging.service";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import {
  constructDataObject,
  getActualValue,
  formatNumber,
  getChange,
  getDisplayLables,
  getPulseCounts,
  initializeMetrics,
  intializeData,
  loadLinkedMatricsData,
  loadPerformanceBenchMarcData,
  processActualValues,
  pushDataToRelevantType,
  reqAgingGraph,
  reqAgingGraphOverview,
  returnSparkLineChart,
  returnSparkLineChartOverView,
  roundToTwoDecimals,
  saveSortedMatricsData,
  getPulsesInfo,
  getScoreCardQuadrantData,
  handleDestroyal,
  handleEditPulse,
  getFormattedVal,
  getPulseTiles,
  handleDataPointsOnTrendGraphs,
} from "./utils/utils";
import {
  getProjectMetrics,
  getTrendData,
  performSearch,
  getRecommenededWidgets,
  getWidgets,
  getMetrics,
  getCreateWidgetPayload,
  handleMetricsDialog,
  handleDeleteWidget,
  handleWidgetUpdation,
  initPerformanceWidgets,
  handleWidgetClone,
  handleWidgetEdit,
} from "./utils/widget-utils";
import { MessageService } from "src/app/shared/services/message.service";
import { FormBuilder, FormControl, Validators } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { DatePipe } from "@angular/common";
import { SurveyService } from "src/app/shared/services/survey.service";
import {
  handleAssessmentAggregateResp,
  handleAuditInstance,
  handleGovAggregateResp,
} from "./utils/additional-info-utils";
import { ZohoService } from "src/app/shared/services/zoho.service";
import { MetricsWhatIfComponent } from "src/app/pages/kepler/metrics-what-if/metrics-what-if.component";
import { FinanceComparitorDialogComponent } from "../../finance-comparitor-dialog/finance-comparitor-dialog.component";
import { BudgetMapComponent } from "../budget-map/budget-map.component";
import { TechMapDialogDataComponent } from "../../tech-map-dialog-data/tech-map-dialog-data.component";
import { CreatePulseDialogComponent } from "src/app/pages/kepler/pulse/create-pulse-dialog/create-pulse-dialog.component";

noData(Highcharts);
More(Highcharts);
HC_solidGauge(Highcharts);
@Component({
  selector: "app-scorecard-dashboard",
  templateUrl: "./scorecard.component.html",
  styleUrls: ["./scorecard.component.scss"],
  providers: [DatePipe],
})
export class ScorecardComponent implements OnInit, OnDestroy {
  Highcharts: typeof Highcharts = Highcharts;
  @ViewChild("slider") public slider: MatSlider;
  @ViewChild("assessmentAccordion", { static: false })
  assessmentAccordion!: ElementRef;
  @ViewChild("assessmentAccordionBtn", { static: false })
  assessmentAccordionBtn!: ElementRef;
  @ViewChild("auditsAccordionBtn", { static: false })
  auditsAccordionBtn!: ElementRef;
  @ViewChild("auditsAccordion", { static: false })
  auditsAccordion!: ElementRef;
  @ViewChild("govAccordionBtn", { static: false }) govAccordionBtn!: ElementRef;
  @ViewChild("govAccordion", { static: false }) govAccordion!: ElementRef;
  @ViewChild("searchMetricsInput", { static: false })
  searchMetricsInput!: ElementRef;
  @Input() projectId: string;
  @Input() pageType: string;
  @Input() showPeopleInsightsButton: string = "false";
  @Input() showFinanceComparitor: boolean = false;
  @Output() scorecardLoading: any = new EventEmitter();
  displayLabels: any;
  deliveryText: any = (textConfiguration as any).delivery;
  commonText: any = (textConfiguration as any).common;
  staticText: any = (textConfiguration as any).common;
  balanceScorecardText: any = (textConfiguration as any).balance_scorecard;
  headerText: string = this.deliveryText?.left_bar.performance_dashboard;
  noDataCustomer = false;
  noDataPeople = false;
  noDataFinance = false;
  noDataDelivery = false;
  matrixOverView = false;
  cardMatric: any;
  whatIfValues: any;
  quadrants: any = {
    customer: "",
    finance: "",
    engineering: "",
    people: "",
  };
  customerData: any;
  financeData: any;
  engineerData: any;
  peopleData: any;
  // Search navigation state
  metricSearchResults: any[] = [];
  currentSearchIndex: number = -1;
  private lastHighlightedElement: HTMLElement | null = null;
  dragPeopleEnableFlag: any[] = [];
  dragEnggEnableFlag: any[] = [];
  dragFinanceEnableFlag: any[] = [];
  dragCustomerEnableFlag: any[] = [];
  performanceBenchMark: any;
  zoomLevel: any;
  linkedMatrics: any = [];
  filterObj: any;
  portfolioId: any = null;
  programId: any = null;
  portfolioName: any = null;
  subportfolioName: any = null;
  programName: any = null;
  projectName: any = null;
  vendorName?: string | null = null;
  subportfolioId: any = null;
  @Input() vendorId: any = null;
  setMetricOverviewDetails: any;
  infoQuadrantName: any;
  quadrantInfoDetails: any;
  user: any;
  isSupportGroup: boolean = false;
  currentMetricId: any;
  pulseCounts: any;
  dataLoaded = false;
  pulseInfoLoaded = false;
  pulsesList: any;
  activeTab: any = 0;
  tableColumns: any = ["Group", "Question", "Responses"];
  auditTableColumns: any = [
    "#",
    "Audit name",
    "Owner",
    "Total # observations",
    "Responses",
  ];
  currentAssessment: any;
  currentAudit: any;
  currentGovAssessment: any;
  assessmentsList: any = [];
  auditsList: any = [];
  govAssessmentsList: any = [];
  auditInstanceInfo: any;
  govAggregateData: any;
  assessmentAggregateData: any;
  additionalInfoLoaded = false;
  enggId = 139;
  peopleId = 137;
  financeId = 138;
  customerId = 140;
  headerInfo = "";
  currentDate = new Date();
  iframeEmbedded = false;
  pulsesInfo: any = [];
  firstTimeLoad = true;
  pulseTableColumns: any = [
    "#",
    "Name",
    "Description",
    "Project",
    "OU/GDP",
    "Raised by",
    "Action",
  ];
  MIN_ITEMS = 5;
  SMALL_BATCH = 10;
  MEDIUM_BATCH = 20;
  LARGE_BATCH = 50;
  XL_BATCH = 100;
  XXL_BATCH = 150;
  MAX_ITEMS = 200;
  sortOpt: any = [
    this.MIN_ITEMS,
    this.SMALL_BATCH,
    this.MEDIUM_BATCH,
    this.LARGE_BATCH,
    this.XL_BATCH,
    this.XXL_BATCH,
    this.MAX_ITEMS,
  ];
  sortOptions: any;
  sortRecords: any = 20;
  CurrentPage: any = 0;
  endValue: any = 20;
  startValue: any = 0;
  widgetsLoaded = false;
  isCreateWidget = false;
  quadrantDialog: any;
  widgetsList: any = [];
  widgetCategories = ["Portfolio", "Sub Portfolio", "Program", "Project"];
  widgetCreateForm: any = this.fb.group({
    name: new FormControl("", [Validators.required]),
    description: new FormControl("", [Validators.required]),
  });
  metricsList: any = [];
  selectedMetrics: any = [];
  metricsTableColumns = ["Metric", "Unit", "Type", "Function", "Action"];
  isWidgetInfo = false;
  currentWidget: any;
  frequencyList = [
    { name: "Daily", value: "daily" },
    { name: "Weekly", value: "weekly" },
    { name: "Monthly", value: "monthly" },
  ];
  frequency: any;
  showLineChart: boolean = false;
  showTrendView = true;
  potData = [];
  potTableColumns = ["Metric Name", "Current Value"];
  trendTableColumns: any = [];
  performanceWidgetFilterForm: any = this.fb.group({
    frequency: [null],
    startDate: [null],
    endDate: [null],
  });
  widgetTrendData: any;
  trendChartOptions: any;
  pointInTimeChartOptions: any;
  isWidgetEditMode = false;
  showRecommendedWidgets = false;
  isPulseTableView = false;
  private readonly unsubscribe$ = new Subject<void>();
  private zohoAPI$: any = new Subject<any>();
  private readonly scoreCardQuadrantSubscription$ = new Subject<void>();
  activeAccordion: string = "assessment";
  projectNumber: any;
  metricSearchTerm: any;
  filteredData: any;
  searchEnabled = false;

  constructor(
    private readonly fb: FormBuilder,
    private readonly datePipe: DatePipe,
    private readonly commonService: CommonService,
    private readonly spinner: NgxSpinnerService,
    private readonly projectService: ProjectService,
    private readonly scorecardService: ScorecardService,
    private readonly filterService: FilterService,
    private readonly dialog: MatDialog,
    private readonly incidentTrackerService: IncidentTrackerService,
    private readonly governanceLighthouseService: GovernanceLighthouseService,
    private readonly assessmentCentralService: AssessmentCentralService,
    private readonly loggingService: LoggingService,
    private readonly messageService: MessageService,
    private readonly toastrService: ToastrService,
    private readonly surveyService: SurveyService,
    private readonly zohoService: ZohoService,
    private readonly router: Router
  ) {
    this.scorecardService.changeMessage("nodata");
    this.loadMetricValueOnclick();
  }

  ngOnInit(): void {
    this.user = JSON.parse(localStorage.getItem("permission") ?? "{}");
    this.messageService
      .getIframeData()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res: any) => {
        this.iframeEmbedded = typeof res != "object";
      });

    getDisplayLables.bind(this)(this.commonService);
    this.pulseTableColumns = [
      "#",
      "Name",
      "Description",
      this.displayLabels?.project,
      "OU/GDP",
      "Raised by",
      "Action",
    ];
    this.widgetCategories = [this.displayLabels?.portfolio, this.displayLabels?.sub_portfolio, this.displayLabels?.program, this.displayLabels?.project];
    if (this.pageType === "projectLevel") {
      getProjectMetrics.bind(this)();
      getScoreCardQuadrantData.bind(this)();
      const selectedProject = localStorage.getItem("selectedProject");
      if (selectedProject) {
        const projectData = JSON.parse(selectedProject);
        this.projectName = projectData.project_name;
        this.projectNumber = projectData.project_id;
      }
      this.showFinanceComparitor = true;
      this.showPeopleInsightsButton = "true";
    } else if (this.pageType === "vendorLevel") {
      getScoreCardQuadrantData.bind(this)();
    } else {
      this.setFilter();
    }

    getPulseCounts.bind(this)(this.projectId);
  }

  setFilter() {
    this.filterService.filterValues
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res: any) => {
        this.filterObj = res;
        this.portfolioId = "";
        this.subportfolioId = "";
        this.programId = "";
        this.projectId = "";
        this.vendorId = "";
        this.headerInfo = "";
        this.portfolioName = "";
        this.subportfolioName = "";
        this.programName = "";
        this.projectName = "";
        this.filterObj?.inputs?.forEach((element: any) => {
          if (element.field === "portfolio") {
            this.portfolioId = element.value?.id;
            this.portfolioName = element.value?.display_name;
            if (this.portfolioId) {
              this.headerInfo += element.value.display_name + " > ";
            }
          }
          if (element.field === "subportfolio") {
            this.subportfolioId = element.value?.id;
            this.subportfolioName = element.value?.display_name;
            if (this.subportfolioId) {
              this.headerInfo += element.value.display_name + " > ";
            }
          }
          if (element.field === "program") {
            this.programId = element.value?.id;
            this.programName = element.value?.display_name;
            if (this.programId) {
              this.headerInfo += element.value.display_name + " > ";
            }
          }
          if (element.field === "project") {
            this.projectId = element.value?.id;
            this.projectNumber = element.value?.project_id;
            this.projectName = element.value?.display_name;
            if (this.projectId) {
              this.headerInfo += element.value.display_name + " > ";
            }
          }
          if (element.field === "vendor") {
            this.vendorId = element.value?.id;
            this.vendorName = element.value?.display_name;
            if (this.vendorId) {
              this.headerInfo += element.value.display_name;
            }
          }
        });
        this.headerInfo = this.headerInfo.trimEnd().replace(/\s>\s*$/, "");
        if (!this.headerInfo) {
          this.headerInfo = this.displayLabels.all_of_it;
        }
        if (this.activeTab === 0) {
          getScoreCardQuadrantData.bind(this)();
          getPulseCounts.bind(this)(
            this.portfolioId,
            this.subportfolioId,
            this.programId,
            this.projectId,
            this.vendorId
          );
        } else if (this.activeTab === 1) {
          if (!this.projectId) {
            this.showRecommendedWidgets = false;
          }
          if (this.showRecommendedWidgets) {
            getRecommenededWidgets.bind(this)();
          } else {
            getWidgets.bind(this)();
          }
        } else if (this.activeTab === 2) {
          if (this.isPulseTableView) {
            getPulsesInfo.bind(this)();
          } else {
            getPulseTiles.bind(this)();
          }
        } else {
          this.getAssessmentsAndAuditsDetails();
        }
      });
  }

  getPulse(card: any, callback: () => void) {
    let qParam = `performance_impact=${card}`;
    if (this.projectId) {
      qParam += `&project=${this.projectId}`;
    } else if (this.programId) {
      qParam += `&program_id=${this.programId}`;
    } else if (this.subportfolioId) {
      qParam += `&subportfolio_id=${this.subportfolioId}`;
    } else if (this.portfolioId) {
      qParam += `&portfolio_id=${this.portfolioId}`;
    }
    if (this.vendorId) {
      qParam += `&vendor_id=${this.vendorId}`;
    }
    this.projectService.getCardPulse(qParam).subscribe((res: any) => {
      this.pulsesList = res;
      intializeData.bind(this)();
      callback();
    });
  }

  showPeopleInsights() {
    const dialog = this.dialog.open(PeopleInsightsComponent, {
      disableClose: true,
      autoFocus: false,
      height: "600px",
      width: "1000px",
      data: {
        portfolioName: this.portfolioName,
        subportfolioName: this.subportfolioName,
        programName: this.programName,
        projectName: this.projectName,
        projectLevel: this.pageType,
        projectNumber: this.projectNumber,
      },
    });
    dialog.afterClosed().subscribe(() => {});
  }

  showCreatePulseDialog() {
    const dialog = this.dialog.open(CreatePulseDialogComponent, {
      width: "50vw",
      maxHeight: "80vh",
      minHeight: "63vh",
      autoFocus: false,
      disableClose: true,
      data: {},
    });
    dialog.afterClosed().subscribe((data) => {
      if (data) {
        if (this.isPulseTableView) {
          getPulsesInfo.bind(this)();
        } else {
          getPulseTiles.bind(this)();
        }
      }
    });
  }

  filterPulsesInfoList(id: number) {
    this.pulsesInfo = this.pulsesInfo.filter((element: any) => element.id !== id)
  }

  showPulses(card: any, activeTab: number) {
    this.getPulse(card, () => {
      const dialog = this.dialog.open(PulsesDialogComponent, {
        panelClass: "no-scroll-dialog",
        height: "auto",
        width: "70vw",
        disableClose: true,
        autoFocus: false,
        data: {
          pulsesList: this.pulsesList,
          card,
          activeTab,
        },
      });
      dialog.afterClosed().subscribe(() => {
        this.getPulse(card, () => {});
      });
    });
  }

  metricValue: any;
  month: any;
  percentValue: any;

  dataToDelivery(type: any, res: any) {
    res.forEach((val: any) => {
      initializeMetrics.bind(this)();
      const { gdpName, gdpValue } = processActualValues.bind(this)(
        val.actual_value
      );
      const lineTrendGrph = this.getLineTrendGraph(val, gdpName, gdpValue);
      const lineTrendOverview = this.getLineTrendOverview(
        val,
        gdpName,
        gdpValue
      );
      const actualValue = getActualValue(val);
      const change = getChange(val);
      const data = constructDataObject.bind(this)(
        val,
        actualValue,
        change,
        lineTrendGrph,
        lineTrendOverview
      );
      pushDataToRelevantType.bind(this)(type, data);
    });
  }

  private getLineTrendGraph(
    val: any,
    gdpName: any[],
    gdpValue: any[],
    forPdf = false
  ): any {
    // Use original width for open_req and experience_profile
    const graphWidth = ["open_req", "experience_profile"].includes(val.name)
      ? 200
      : 130;
    if (val.name === "req_aging" || val.name === "open_req") {
      return reqAgingGraph(
        graphWidth,
        100,
        val?.data?.range,
        val?.data?.value.map(roundToTwoDecimals),
        "Days"
      );
    } else if (val.name === "gdp_survey_rating") {
      return reqAgingGraph(graphWidth, 100, gdpName, gdpValue, "Avg. Score");
    } else if (val.name === "experience_profile") {
      return returnSparkLineChart(
        [
          {
            data: val?.actual_value[
              val?.actual_value.length - 1
            ]?.data?.value.map(roundToTwoDecimals),
          },
        ],
        "column",
        val?.actual_value[val?.actual_value.length - 1]?.data?.range,
        forPdf
      );
    } else {
      return returnSparkLineChart(
        [{ data: this.metricValue.map(roundToTwoDecimals) }],
        "line",
        this.month,
        forPdf
      );
    }
  }

  private getLineTrendOverview(val: any, gdpName: any[], gdpValue: any[]): any {
    if (val.name === "req_aging") {
      return reqAgingGraphOverview(
        val?.data?.range,
        val?.data?.value.map(roundToTwoDecimals),
        val?.display_name,
        "Days Open",
        "Count of Open Reqs"
      );
    } else if (val.name === "gdp_survey_rating") {
      return reqAgingGraphOverview(
        gdpName,
        gdpValue,
        val?.display_name,
        "GDP Name",
        "Actual Value"
      );
    } else if (val.name === "experience_profile") {
      return returnSparkLineChartOverView(
        [
          {
            data: val?.actual_value[
              val?.actual_value.length - 1
            ]?.data?.value.map(roundToTwoDecimals),
          },
        ],
        "column",
        val?.actual_value[val?.actual_value.length - 1]?.data?.range
      );
    } else {
      return returnSparkLineChartOverView(
        [{ data: this.metricValue.map(roundToTwoDecimals) }],
        "line",
        this.month
      );
    }
  }

  drop(event: CdkDragDrop<string[]>, quadrantId: any) {
    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
      saveSortedMatricsData.bind(this)(event.container.data, quadrantId);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
      saveSortedMatricsData.bind(this)(event.container.data, quadrantId);
    }

    if (quadrantId === this.customerId) {
      this.dragCustomerEnableFlag[event.previousIndex] = "true";
    }
    if (quadrantId === this.financeId) {
      this.dragFinanceEnableFlag[event.previousIndex] = "true";
    }
    if (quadrantId === this.enggId) {
      this.dragEnggEnableFlag[event.previousIndex] = "true";
    }
    if (quadrantId === this.peopleId) {
      this.dragPeopleEnableFlag[event.previousIndex] = "true";
    }
  }

  enableDragClick(i: any, type: any) {
    if (type === this.customerId) {
      this.dragCustomerEnableFlag[i] = "false";
    }
    if (type === this.financeId) {
      this.dragFinanceEnableFlag[i] = "false";
    }
    if (type === this.enggId) {
      this.dragEnggEnableFlag[i] = "false";
    }
    if (type === this.peopleId) {
      this.dragPeopleEnableFlag[i] = "false";
    }
  }

  clickOverView(type: any, metric: any, cardDetails: any, cardName: any) {
    if (this.user?.is_vendor) {
      return;
    }
    this.whatIfValues = cardDetails;
    const data: any = {
      metric,
      cardDetails,
      cardName,
    };
    this.setMetricOverviewDetails = {
      metric_id: metric?.id,
      quadrant_id: type,
      quadrant_name: cardName,
    };
    this.scorecardService.changeMessage(data);
    this.currentMetricId = metric.id;
  }

  setBIZoomLevel() {
    const large = 1500;
    const mid = 1246;
    if (window.innerWidth > large) {
      this.zoomLevel = 0.6;
    } else if (window.innerWidth <= large && window.innerWidth > mid) {
      this.zoomLevel = 0.5;
    } else if (window.innerWidth < mid) {
      this.zoomLevel = 0.4;
    } else {
      this.loggingService.warn("Unexpected value");
    }
  }

  loadMetricValueOnclick() {
    this.scorecardService.cardDetails.subscribe((cards: any) => {
      if (cards?.cardName) {
        let queryParams = "metric_id=" + cards?.metric?.id;

        if (this.projectId) {
          queryParams += `&project_id=${this.projectId}`;
        }
        if (this.programId) {
          queryParams += `&program_id=${this.programId}`;
        }
        if (this.portfolioId) {
          queryParams += `&portfolio_id=${this.portfolioId}`;
        }

        if (this.subportfolioId) {
          queryParams += `&subportfolio_id=${this.subportfolioId}`;
        }

        if (this.vendorId) {
          queryParams += `&vendor_id=${this.vendorId}`;
        }

        if (this.zohoAPI$) {
          this.zohoAPI$.next();
          this.zohoAPI$ = new Subject<any>();
        }

        this.zohoAPI$ = this.zohoService
          .getZohoReport(queryParams)
          .subscribe((res: any) => {
            this.cardMatric = cards?.metric;
            if (res.data.length) {
              this.cardMatric.zohoURL = res.data[0].url;
            }

            this.matrixOverView = true;
            this.messageService.setGnews({
              pagename: "Balanced Scorecard - Individual",
              queryParam: {
                metric_list: JSON.stringify({
                  name: cards?.metric?.name,
                  description: cards?.metric?.desc,
                }),
              },
            });
            loadLinkedMatricsData.bind(this)(cards?.metric?.id);
            loadPerformanceBenchMarcData.bind(this)(cards?.metric?.id);
          });
      } else {
        this.matrixOverView = false;
      }
    });
  }

  closeMatrixOverview() {
    this.scorecardService.changeMessage("nodata");
    this.matrixOverView = false;
    getScoreCardQuadrantData.bind(this)();
  }

  getDifference(itemActualValue: any, metricActualValue: any) {
    let val: any = itemActualValue - metricActualValue;
    val = parseFloat(val).toFixed(2);
    return val || 0;
  }

  quadrantInfo(type: any, modal: any, quadrantName: any) {
    this.infoQuadrantName = quadrantName;
    this.quadrantDialog = this.dialog.open(modal, {
      width: "auto",
      height: "auto",
      disableClose: true,
      autoFocus: false,
    });
    this.spinner.show();
    this.projectService.quadrantIfo(type).subscribe((res: any) => {
      this.spinner.hide();
      this.quadrantInfoDetails = res;
    });
  }

  dialogClose() {
    this.quadrantDialog.close();
  }

  formatNumber(number: any, decimalPlaces: number): string {
    return getFormattedVal(number);
  }

  openWhatIfModel() {
    this.dialog.open(MetricsWhatIfComponent, {
      width: "65vw",
      maxHeight: "85vh",
      minHeight: "28vh",
      disableClose: true,
      autoFocus: false,
      data: {
        page: "balance scorecard",
        metricId: this.currentMetricId,
        portfolioId: this.portfolioId,
        subportfolioId: this.subportfolioId,
        programId: this.programId,
        projectId: this.projectId,
        displayLabels: this.displayLabels,
      },
    });
  }

  getContribution(item: any, cardMatricValue: any) {
    let currentItemValue = 0;
    const actualVal =
      item?.actual_value[item?.actual_value.length - 1]?.actual_value;
    if (actualVal) {
      currentItemValue = actualVal;
    }
    const contri = (currentItemValue / cardMatricValue) * 100;
    return roundToTwoDecimals(contri);
  }

  getAssessmentsAndAuditsDetails() {
    this.govAggregateData = null;
    this.assessmentAggregateData = null;
    this.auditInstanceInfo = null;

    forkJoin({
      assessments: this.projectService.getAssessments(
        this.projectId,
        this.portfolioId,
        this.subportfolioId,
        this.programId,
        this.vendorId
      ),
      audits: this.projectService.getAudits(
        this.projectId,
        this.portfolioId,
        this.subportfolioId,
        this.programId,
        this.vendorId
      ),
      govAssessments: this.projectService.getGovAssessments(
        this.projectId,
        this.portfolioId,
        this.subportfolioId,
        this.programId,
        this.vendorId
      ),
    }).subscribe((response: any) => {
      this.assessmentsList = response.assessments.records;
      this.currentAssessment = this.assessmentsList[0]?.id;
      if (this.currentAssessment) {
        this.getAssessmentAggregateUserResponse();
      }
      this.auditsList = response.audits.records;
      this.currentAudit = this.auditsList[0]?.id;
      if (this.currentAudit) {
        this.getAuditInstanceInfo();
      }
      this.govAssessmentsList = response.govAssessments.records;
      this.currentGovAssessment = this.govAssessmentsList[0]?.id;
      if (this.currentGovAssessment) {
        this.getGovAggregateUserResponse();
      }
      if (this.assessmentsList.length) {
        this.activeAccordion = "assessment";
      } else if (this.auditsList.length) {
        this.activeAccordion = "audit";
      } else if (this.govAssessmentsList.length) {
        this.activeAccordion = "gov";
      } else {
        this.activeAccordion = "assessment";
      }
    });
  }

  getRecords() {
    if (this.CurrentPage > 0) {
      this.startValue =
        (parseInt(this.CurrentPage, 10) - 1) * parseInt(this.sortRecords, 10);
    } else {
      this.startValue = 0;
    }
    this.endValue =
      parseInt(this.startValue, 10) + parseInt(this.sortRecords, 10);
    if (!this.firstTimeLoad) {
      getPulsesInfo.bind(this)();
    }
    this.firstTimeLoad = false;
  }

  changeTab(event: any) {
    this.activeTab = event.index;
    if (this.activeTab === 0) {
      if (this.pageType === "projectLevel") {
        getProjectMetrics.bind(this)();
      }
      getScoreCardQuadrantData.bind(this)();
    } else if (this.activeTab === 1) {
      this.performanceWidgetFilterForm.reset();
      this.setupPerformanceWidgetFilters();
      initPerformanceWidgets.bind(this)();
      getWidgets.bind(this)();
    } else if (this.activeTab === 2) {
      if (this.isPulseTableView) {
        getPulsesInfo.bind(this)();
      } else {
        getPulseTiles.bind(this)();
      }
    } else if (this.activeTab === 3) {
      this.setAssessmentGnews();
      this.getAssessmentsAndAuditsDetails();
    }
  }

  setAssessmentGnews() {
    this.messageService.setGnews({
      pagename: "Additional Info - Assessments & Audits",
    });
  }

  downloadEvidence(instanceId: any, evidenceMetadata: any) {
    this.incidentTrackerService.downloadEvidence(instanceId).subscribe(
      (res: any) => {
        const downloadLink = document.createElement("a");
        downloadLink.href = window.URL.createObjectURL(res);
        const fileName = evidenceMetadata[0];
        downloadLink.setAttribute("download", fileName);
        document.body.appendChild(downloadLink);
        downloadLink.click();
      },
      (error: any) => {
        throw error;
      }
    );
  }

  getAuditInstanceInfo() {
    handleAuditInstance.bind(this)();
  }

  getGovAggregateUserResponse() {
    handleGovAggregateResp.bind(this)();
  }

  getAssessmentAggregateUserResponse() {
    handleAssessmentAggregateResp.bind(this)();
  }

  async downloadPDF(tooltip: any) {
    tooltip.show();
    setTimeout(() => tooltip.hide(), 1000);
    const page: any = document.getElementById("cardsContainer");
    if (page) {
      this.dataLoaded = false;
      this.scorecardLoading.emit(false);
      handleDataPointsOnTrendGraphs.bind(this)(true);
      page.style.padding = "15px";
      const bscHeader: any = document.getElementById("bscHeader");
      bscHeader.classList.remove("hidden");
      // Prepare bscCards for rendering PDF
      const bscCards: any = page.getElementsByClassName("bsc-card-container");
      for (let bscCard of bscCards) {
        bscCard.classList.add("w-100");
        const tables: any = page.getElementsByClassName("bsc-card");
        for (let table of tables) {
          table.classList.remove("table-responsive");
          table.style.height = "auto";
        }
      }
      await new Promise((resolve) => setTimeout(resolve, 1000));
      html2canvas(page, {
        scrollY: -window.scrollY,
        useCORS: true,
        scale: 2,
      }).then((canvas) => {
        const imageQuality = 0.7;
        const imgData = canvas.toDataURL("image/jpeg", imageQuality); // Use JPEG, quality set to 0.7
        // Create PDF
        const pdf = new jsPDF("p", "mm", "a4");
        const imgWidth = 210; // A4 page width in mm
        const pageHeight = 297; // A4 page height in mm
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        let heightLeft = imgHeight;
        let position = 0;
        // Add content to PDF and handle page breaks
        pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
        while (heightLeft > 0) {
          position = heightLeft - imgHeight;
          pdf.addPage();
          pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;
        }
        pdf.save("scorecard.pdf");
        // Restore the original styles
        bscHeader.classList.add("hidden");
        for (let bscCard of bscCards) {
          bscCard.classList.remove("w-100");
          const tables: any = page.getElementsByClassName("bsc-card");
          for (let table of tables) {
            table.classList.add("table-responsive");
            table.style.height = "310px";
          }
        }
        page.style.padding = "0px";
        handleDataPointsOnTrendGraphs.bind(this)();
        this.dataLoaded = true;
        this.scorecardLoading.emit(true);
      });
    }
  }

  getFormattedValue(val: number) {
    const value = getFormattedVal(val);
    return value;
  }

  showEditPulseDialog(pulse: any) {
    handleEditPulse.bind(this)(pulse);
  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions to avoid memory leaks
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  editWidget(widget: any) {
    handleWidgetEdit.bind(this)(widget);
  }

  openWidget(widget: any) {
    this.isWidgetInfo = true;
    this.showLineChart = false;
    this.currentWidget = widget;
    this.performanceWidgetFilterForm.get("frequency").setValue("monthly");
  }

  navigateBack() {
    initPerformanceWidgets.bind(this)();
    getWidgets.bind(this)();
    this.widgetCreateForm.enable();
  }

  addWidget() {
    this.isCreateWidget = true;
    this.isWidgetEditMode = false;
  }

  createWidget() {
    const payload = getCreateWidgetPayload.bind(this)();
    this.dataLoaded = false;
    this.scorecardService.createWidget(payload).subscribe(() => {
      this.toastrService.success("Widget created successfully");
      this.dataLoaded = true;
      this.navigateBack();
    });
  }

  updateWidget() {
    handleWidgetUpdation.bind(this)();
  }

  removeMetric(metric: any) {
    this.selectedMetrics = this.selectedMetrics.filter(
      (item: any) => item.id !== metric.id
    );
  }

  showAddMetricDialog(isProjectLevel = false) {
    getMetrics
      .bind(this)()
      .subscribe(() => {
        handleMetricsDialog.bind(this)(isProjectLevel);
      });
  }

  toggleView(evt: any) {
    this.showLineChart = evt.checked;
  }

  toggleTrendAndPointInTime() {
    this.showTrendView = !this.showTrendView;
    const freq = this.performanceWidgetFilterForm.get("frequency")?.value;
    this.showLineChart = false;
    if (!this.showTrendView) {
      const currentDate = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      getTrendData.bind(this)(null, currentDate, currentDate);
    } else {
      getTrendData.bind(this)(freq);
    }
  }

  toggleRecommendedWidgets() {
    this.showRecommendedWidgets = !this.showRecommendedWidgets;
    if (this.showRecommendedWidgets) {
      getRecommenededWidgets.bind(this)();
    } else {
      getWidgets.bind(this)();
    }
  }

  setupPerformanceWidgetFilters(): void {
    this.performanceWidgetFilterForm.valueChanges.subscribe((values: any) => {
      performSearch.bind(this)(values);
    });
  }

  showDeleteConfirmation(widget: any) {
    handleDeleteWidget.bind(this)(widget);
  }

  cloneWidget() {
    handleWidgetClone.bind(this)();
  }

  togglePulseView(event: any) {
    this.isPulseTableView = event.checked;
    if (this.isPulseTableView) {
      getPulsesInfo.bind(this)();
    } else {
      getPulseTiles.bind(this)();
    }
  }

  getBenchmarkTableHeader() {
    if (this.projectId || this.programId) {
      return this.displayLabels.project;
    } else if (this.subportfolioId) {
      return this.displayLabels.program;
    } else if (this.portfolioId) {
      return this.displayLabels.sub_portfolio;
    } else if (this.vendorId) {
      return "Delivery Partner";
    } else {
      return this.displayLabels.portfolio;
    }
  }

  getTooltipText(mosType: any) {
    if (mosType === "HTB") {
      return "Higher the better";
    } else if (mosType === "LTB") {
      return "Lower the better";
    } else {
      return "";
    }
  }

  isValidUrl(url: any) {
    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  }

  // Add these methods to handle accordion open events
  openAccordion(panel: string) {
    this.activeAccordion = panel;
  }

  onAssessmentChange() {
    this.openAccordion("assessment");
    this.getAssessmentAggregateUserResponse();
  }

  onAuditChange() {
    this.openAccordion("audit");
    this.getAuditInstanceInfo();
  }

  onGovAssessmentChange() {
    this.openAccordion("gov");
    this.getGovAggregateUserResponse();
  }

  openBugetMap(): void {
    this.dialog.open(BudgetMapComponent, {
      width: "900px",
      maxWidth: "95vw",
      height: "80vh",
      maxHeight: "800px",
      data: {
        portfolioId: this.portfolioId,
        subportfolioId: this.subportfolioId,
        programId: this.programId,
        projectId: this.projectId,
        vendorId: this.vendorId,
        portfolioName: this.portfolioName,
        subportfolioName: this.subportfolioName,
        programName: this.programName,
        projectName: this.projectName,
        vendorName: this.vendorName,
        isBreadcrumb: true,
      },
      disableClose: false,
    });
  }

  openFinanceComparitor() {
    this.dialog.open(FinanceComparitorDialogComponent, {
      width: "80vw",
      maxHeight: "80vh",
      data: {
        portfolioId: this.portfolioId,
        subportfolioId: this.subportfolioId,
        programId: this.programId,
        projectId: this.projectId,
        vendorId: this.vendorId,
        portfolioName: this.portfolioName,
        subportfolioName: this.subportfolioName,
        programName: this.programName,
        projectName: this.projectName,
        vendorName: this.vendorName,
      },
    });
  }

  openTechMap(): void {
    this.dialog.open(TechMapDialogDataComponent, {
      width: "800px",
      maxWidth: "95vw",
      maxHeight: "80vh",
      data: {
        portfolioId: this.portfolioId,
        subportfolioId: this.subportfolioId,
        programId: this.programId,
        projectId: this.projectId,
        vendorId: this.vendorId,
        vendorName: this.vendorName,
        portfolioName: this.portfolioName,
        subportfolioName: this.subportfolioName,
        programName: this.programName,
        projectName: this.projectName,
        isBreadcrumb: true,
      },
      disableClose: false,
    });
  }

  onSearchEnableClicked() {
    this.searchEnabled = !this.searchEnabled;
    if (this.searchEnabled) {
      setTimeout(() => {
        this.searchMetricsInput.nativeElement.focus();
      }, 100);
    }
  }

  onMetricSearch(): void {
    const searchLower = (this.metricSearchTerm || "").toLowerCase().trim();

    // reset previous search results
    this.metricSearchResults = [];
    this.currentSearchIndex = -1;
    this.clearHighlight();

    if (!searchLower) {
      return;
    }

    // search in the four quadrants in a deterministic order
    const lists = [
      this.customerData,
      this.financeData,
      this.engineerData,
      this.peopleData,
    ];
    for (const list of lists) {
      if (!Array.isArray(list)) {
        continue;
      }
      for (const metric of list) {
        const name = (metric?.name || "").toString().toLowerCase();
        if (name.includes(searchLower)) {
          this.metricSearchResults.push(metric);
        }
      }
    }

    if (this.metricSearchResults.length > 0) {
      this.currentSearchIndex = 0;
      // scroll to the first match
      this.scrollToMetricById(this.metricSearchResults[0]?.id);
    }
  }

  goToNextSearchResult(): void {
    if (!this.metricSearchResults || this.metricSearchResults.length === 0)
      return;
    this.currentSearchIndex =
      (this.currentSearchIndex + 1) % this.metricSearchResults.length;
    const metric = this.metricSearchResults[this.currentSearchIndex];
    this.scrollToMetricById(metric?.id);
  }

  goToPrevSearchResult(): void {
    if (!this.metricSearchResults || this.metricSearchResults.length === 0)
      return;
    this.currentSearchIndex =
      (this.currentSearchIndex - 1 + this.metricSearchResults.length) %
      this.metricSearchResults.length;
    const metric = this.metricSearchResults[this.currentSearchIndex];
    this.scrollToMetricById(metric?.id);
  }

  private scrollToMetricById(id: any): void {
    if (!id && id !== 0) return;
    const el = document.getElementById(`metric-${id}`) as HTMLElement | null;
    if (el) {
      // Scroll the outer card container into view so the page moves to
      // the quadrant, then center the metric inside the inner `.bsc-card`.
      const outerContainer = el.closest(
        ".bsc-card-container"
      ) as HTMLElement | null;
      const cardContainer = el.closest(".bsc-card") as HTMLElement | null;

      const doInnerScroll = () => {
        if (
          cardContainer &&
          cardContainer.scrollHeight > cardContainer.clientHeight
        ) {
          // compute element position relative to container and center it
          const containerRect = cardContainer.getBoundingClientRect();
          const elRect = el.getBoundingClientRect();
          const offset =
            elRect.top -
            containerRect.top +
            cardContainer.scrollTop -
            cardContainer.clientHeight / 2 +
            el.clientHeight / 2;
          try {
            cardContainer.scrollTo({ top: offset, behavior: "smooth" });
          } catch (e) {
            cardContainer.scrollTop = offset;
          }
        } else {
          // fallback to scrolling the element into view on the page
          try {
            el.scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "nearest",
            });

            // Immediately correct any horizontal scroll that browser tried
            window.scrollTo({
              left: 0,
              top: window.scrollY,
              behavior: "auto",
            });
          } catch (e) {
            el.scrollIntoView();
          }
        }
      };

      if (outerContainer) {
        try {
          el.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "nearest",
          });

          // Immediately correct any horizontal scroll that browser tried
          window.scrollTo({
            left: 0,
            top: window.scrollY,
            behavior: "auto",
          });
        } catch (e) {
          outerContainer.scrollIntoView();
        }
        // wait briefly for the outer container to move before computing inner offsets
        setTimeout(doInnerScroll, 220);
      } else {
        doInnerScroll();
      }
      this.highlightElement(el);
    }
  }

  private highlightElement(el: HTMLElement): void {
    // remove previous
    if (this.lastHighlightedElement) {
      this.lastHighlightedElement.classList.remove("highlighted");
    }
    el.classList.add("highlighted");
    this.lastHighlightedElement = el;
  }

  /**
   * Whether there is an active highlight or search results visible.
   * Used by the template to enable/disable the clear button.
   */
  get hasActiveHighlight(): boolean {
    return (
      (this.metricSearchResults && this.metricSearchResults.length > 0) ||
      !!this.lastHighlightedElement
    );
  }

  /**
   * Public handler invoked by the Cancel/Clear button to remove highlights
   * and reset search navigation state.
   */
  clearSearchHighlight(): void {
    this.clearHighlight();
    this.metricSearchResults = [];
    this.currentSearchIndex = -1;
    this.metricSearchTerm = "";
  }

  private clearHighlight(): void {
    if (this.lastHighlightedElement) {
      this.lastHighlightedElement.classList.remove("highlighted");
      this.lastHighlightedElement = null;
    }
  }
}
